import "./styles/app.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "./components/Header";
import Login from "./components/Login";
import { AuthProvider } from "./context/AuthContext";
import Account from "./components/Account";
import PrivateRoute from "./PrivateRoute";
import Register from "./components/Register";
import Verified from "./components/Verified";
import ResetPassword from "./components/ResetPassword";
import RecoverAccount from "./components/RecoverAccount";
import NewPassword from "./components/NewPassword";
import Home from "./components/Home";
import News from "./components/News";
import Files from "./components/Files";
import FullNews from "./components/FullNews";

function App() {
  return (
    <div className="app">
      <div className="app__body">
        <Router>
          <AuthProvider>
            <Switch>
              <Route exact path="/">
                <Header />
                <Home />
                <News />
              </Route>
              <Route path="/login">
                <Header />
                <Home />
                <Login />
              </Route>
              <Route path="/register">
                <Header />
                <Home />
                <Register />
              </Route>
              <PrivateRoute path="/account" component={Account}></PrivateRoute>
              <Route path="/verified">
                <Header />
                <Home />
                <Verified />
              </Route>
              <PrivateRoute
                path="/resetPassword"
                component={ResetPassword}
              ></PrivateRoute>
              <Route path="/recoverAccount">
                <Header />
                <Home />
                <RecoverAccount />
              </Route>
              <Route path="/newPassword">
                <Header />
                <Home />
                <NewPassword />
              </Route>
              <Route path="/files">
                <Header />
                <Home />
                <Files />
              </Route>
              <Route path="/fullNews">
                <Header />
                <Home />
                <div className="mobile">
                  <News />
                </div>
                <div className="pc">
                  <FullNews />
                </div>
              </Route>
            </Switch>
          </AuthProvider>
        </Router>
      </div>
    </div>
  );
}

export default App;
